jQuery(document).ready(function ($) {


    function general(){
        $('.expand-announcement-btn').on('click', function(){
            $('.expanded-announcement').addClass('active');
        });

        $('.close-expand-announcement').on('click', function(){
            $('.expanded-announcement').removeClass('active');
        });
    }

    function setAnnouncement(){
        var announcementBannerHeight = $('.announcement-bar').outerHeight(),
            // currBodyPadding = parseInt($('body').css('padding-top')),
            currMobileMenuTop = parseInt($('#menu-mobile-menu').css('margin-top')),
            currHeaderHeight = parseInt($('#global-header').css('height'));

        if( $('.announcement-bar').length > 0 ){
            
            console.log('x');

            $('body').css('padding-top', announcementBannerHeight + currHeaderHeight )
            // $('#global-header').css('top', announcementBannerHeight );
            $('.desktop-header-dropdown').css('top', currHeaderHeight + announcementBannerHeight );

        } else {
            // $('#shop-dropdown').css('top', currHeaderHeight );
            $('body').css('padding-top', currHeaderHeight );
        }
    }
    


    function slick_sliders(){


        if( $('.slick-initt').length > 0 ) {
            $('.slick-initt').slick({
                dots: false,
                infinite: true,
                speed: 800,
                autoplaySpeed: 3500,
                draggable: true,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: true,

                easing: 'easeOutCubic',
                autoplay: true,
                arrows: false,  

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }



        if( $('.slick-initt-arrow').length > 0 ) {
            console.log('on'); 
            $('.slick-initt-arrow')
              .on('init', function(event, slick, currentSlide, nextSlide) {
                    console.log('init');

                    
              })
              .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                    console.log('beforeChange'); 
                    // $('.the-slide .zoomit').trigger('zoom.destroy');
              })
              .on('afterChange', function(event, slick, currentSlide, nextSlide) {
                    console.log('afterChange'); 
                    // $('.the-slide.slick-current .zoomit').zoom();
              })
              .slick({
                dots: false,
                infinite: false,
                speed: 800,
                autoplaySpeed: 3500,
                draggable: false,

                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                centerPadding: '0',
                variableWidth: false,
                adaptiveHeight: true,

                easing: 'easeOutCubic',
                autoplay: false,
                arrows: false,  
                // appendArrows: '#arrow-container', 
                prevArrow: '<button type="button" class="slick-prev"><svg width="13px" height="26px" viewBox="0 0 13 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Large-Display" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Homepage-Copy" transform="translate(-234.000000, -1382.000000)" stroke="#6d5527"><polyline id="Line-3-Copy-2" transform="translate(240.500000, 1395.000000) scale(-1, 1) rotate(-90.000000) translate(-240.500000, -1395.000000) " points="228.5 1388.5 240.438279 1401.5 252.5 1388.5"></polyline></g></g></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="13px" height="26px" viewBox="0 0 13 26" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Large-Display" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square"><g id="Homepage-Copy" transform="translate(-1550.000000, -1382.000000)" stroke="#6d5527"><polyline id="Line-3-Copy-2" transform="translate(1556.500000, 1395.000000) rotate(-90.000000) translate(-1556.500000, -1395.000000) " points="1544.5 1388.5 1556.43828 1401.5 1568.5 1388.5"></polyline></g></g></svg> </button>',
                asNavFor: '.slick-initt-thumbs',

                responsive: [
                  {
                    breakpoint: 800,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    arrows: false, 
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
            });
        }

        if( $(window).width() > 480) {
                        console.log('start > 480');
                        $('.the-slide .zoomit').zoom({
                            magnify: 1.25
                        });

                    } else {
                        console.log('start < 480');
                        $('.the-slide .zoomit').trigger('zoom.destroy').removeClass('zoomit');
                        $('.zoomImg').removeClass('zoomImg');
                        $('.product-slide').unwrap();
                    }

        if( $('.slick-initt-thumbs').length > 0 ){
            $('.slick-initt-thumbs').slick({
                // $('#single-portfolio-slider-184-nav-exhibit .inner').slick({
                    slidesToShow: 300,
                    slidesToScroll: 1,
                    infinite: false,
                    asNavFor: '.slick-initt-arrow',
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true
                }).on('reInit', function(event, slick, currentSlide, nextSlide) {
                    console.log('REinit'); 
              });
        }


    };

    $(window).ready(function(){
        general();
        setAnnouncement();  
    });

    $(window).load(function(){
        // slick_sliders();
    });


    $(window).resize(function(){
       setAnnouncement();
    });
});     